import React from "react";
import Logo from "components/Logo";
import Divider from "components/Logo/Divider";
import dayjs from "dayjs";
import "dayjs/locale/fr";

interface ReservationHeaderProps {
  contractorName?: string;
  contractorLogoUrl?: string;
  date?: string;
  halfday?: string;
}

const ReservationHeader = ({
  contractorName,
  contractorLogoUrl,
  date,
  halfday,
}: ReservationHeaderProps) => {
  dayjs.locale("fr");

  const formattedDate = React.useMemo(() => {
    if (!date) return "";
    return dayjs(date).format("dddd D MMMM YYYY");
  }, [date]);

  const halfdayLabel = React.useMemo(() => {
    if (halfday === "morning") return "Matin";
    if (halfday === "afternoon") return "Après-midi";
    return "";
  }, [halfday]);

  return (
    <div className="header">
      <Logo />
      <Divider />
      {contractorLogoUrl && (
        <img
          className="reservation-header__contractor-logo"
          src={contractorLogoUrl}
          alt={contractorName || ""}
        />
      )}
      <div className="header__order-title">
        <div className="reservation-header__title">Votre réservation</div>
        {contractorName && (
          <div className="reservation-header__contractor-name">
            {contractorName}
          </div>
        )}
        {date && (
          <div className="header__confirmed-date">
            <div>{formattedDate}</div>
            {halfdayLabel && (
              <div className="header__confirmed-date__message">{halfdayLabel}</div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ReservationHeader;
